import { ref } from "firebase/database";
import { NotificationPath } from "intake_shared/src/notification";
import { rtdb } from "../utils/firestore";

export function getClientChangesNotificationRef(client_id: string) {
    const clientChangeNotificationPath = `${NotificationPath.CLIENT_CHANGE_NOTIFICATION}/${client_id}`;
    return ref(rtdb, clientChangeNotificationPath);
}
